import React, {useState, useEffect} from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Video from './components/video/Video';
import { db } from './firebase';


function App() {

  const [videos, setVideos] = useState([])

  useEffect( () => {
    db.collection("videos").onSnapshot(snapshot => setVideos(snapshot.docs.map(doc => doc.data())))
  }, [])

  return (
    <Router>
      <div className="app">
        <div className="app__videos">
          {videos.map(
            ({id,messages, url, likes, shares, description, channel, song}, i) => {
              console.log(id)
              return <Video
                key={i}
                messages={messages}
                likes={likes}
                shares={shares}
                description={description}
                channel={channel}
                song={song}
                url={url}
              />
            }
             
            )
          }
          {/* <Video
            url="https://v16m.tiktokcdn.com/c91d9b18e85b94fc064be740358394b4/5f47cb01/video/tos/useast2a/tos-useast2a-pve-0068/3d96b84a558d49a8a4210b4daeed499d/?a=1233&br=3838&bt=1919&cr=0&cs=0&dr=0&ds=3&er=&l=202008251502250101891960701D08E8BB&lr=tiktok_m&mime_type=video_mp4&qs=0&rc=M2o4aGR4O2VwdTMzZjczM0ApOjpoZDY4NWVkNzkzZ2Q2PGduLTZlLzFvbDRfLS1eMTZzcy5jMy8tNS5hXmJiL18wXzA6Yw%3D%3D&vl=&vr="
            messages={123}
            likes={33}
            shares={50}
            song="tekno"
            description="Fill my dance moves"
            channel="emmanuelhashy"
          /> */}
          {/* <Video/>
          <Video/>
          <Video/> */}
        </div>
      </div>
    </Router>
  );
}

export default App;
